@if (rule) {
  <div class="flex gap-2">
    <app-icon name="ic_irrigation"/>
    <div>
      <h4 class="line-clamp">{{ rule | ruleName }}</h4>
      <p>{{ description }}</p>
    </div>
    <a class="button icon-button end" [routerLink]="['/', RouteConstants.routeRule, rule.id]">
      <app-icon name="ic_chevron_right"/>
    </a>
  </div>
}
